import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("上传")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("批量上传图片")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 新建卡牌 ")
const _hoisted_9 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("只处理没有图片的")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("覆盖所有")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("选择文件")
const _hoisted_19 = {
  class: "ms-2 text-muted",
  style: {"font-size":"13px"}
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("开始上传")
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  class: "mb-3",
  style: {"font-size":"14px","color":"#606266"}
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 已匹配 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 张 / 未匹配 ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 张 ")
const _hoisted_27 = {
  class: "mb-2",
  style: {"font-size":"13px","color":"#909399"}
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"600","margin-bottom":"6px","font-size":"13px"} }, "处理明细", -1)
const _hoisted_30 = { style: {"max-height":"400px","overflow-y":"auto","border":"1px solid #ebeef5","border-radius":"4px"} }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("成功")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("跳过")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("失败")
const _hoisted_34 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_35 = { style: {"font-weight":"600","margin-bottom":"6px","font-size":"13px","color":"#e6a23c"} }
const _hoisted_36 = { style: {"max-height":"120px","overflow-y":"auto","background":"#fdf6ec","border-radius":"4px","padding":"8px 12px"} }
const _hoisted_37 = { style: {"color":"#c0a06c"} }
const _hoisted_38 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_39 = { style: {"font-weight":"600","margin-bottom":"6px","font-size":"13px","color":"#f56c6c"} }
const _hoisted_40 = { style: {"max-height":"100px","overflow-y":"auto","background":"#fef0f0","border-radius":"4px","padding":"8px 12px"} }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, {
            field: "name",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                placeholder: "卡牌名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "card_series_id",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.card_series_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.card_series_id) = $event)),
                placeholder: "所属系列",
                clearable: "",
                filterable: "",
                style: {"width":"150px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardSeriesOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "card_rarity_id",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.card_rarity_id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.card_rarity_id) = $event)),
                placeholder: "稀有度",
                clearable: "",
                style: {"width":"120px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rarityOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "card_version_id",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.card_version_id,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.card_version_id) = $event)),
                placeholder: "版本",
                clearable: "",
                filterable: "",
                style: {"width":"120px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versionOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "enabled",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.enabled,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.enabled) = $event)),
                placeholder: "状态",
                clearable: "",
                style: {"width":"100px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "启用",
                    value: "true"
                  }),
                  _createVNode(_component_el_option, {
                    label: "停用",
                    value: "false"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onDownload
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onUpload
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createElementVNode("input", {
                id: "btn_upload",
                type: "file",
                accept: ".xlsx,.xls",
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                style: {"display":"none"}
              }, null, 32),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onOpenZipUploadDialog
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createElementVNode("input", {
                ref: "zipInputRef",
                type: "file",
                accept: ".zip",
                style: {"display":"none"},
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onZipFileChange && _ctx.onZipFileChange(...args)))
              }, null, 544),
              _createVNode(_component_router_link, {
                to: { name: 'cards_management_new' },
                class: "btn btn-success ms-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID",
          width: "60"
        }),
        _createVNode(_component_vxe_column, {
          title: "图片",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            (row.image)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  src: row.image,
                  "preview-src-list": [row.image],
                  fit: "cover",
                  style: {"width":"50px","height":"50px"}
                }, null, 8, ["src", "preview-src-list"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "name",
          title: "名称",
          width: "150"
        }),
        _createVNode(_component_vxe_column, {
          title: "所属系列",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.card_series?.name || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "稀有度",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, {
              type: _ctx.getRarityTagType(row.rarity),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.rarity_display || row.rarity), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "语系",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.card_language?.name || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "版本号",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.card_version?.name || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "关联商品",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            (row.product)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(row.product.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "状态",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            (row.enabled)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "success",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "info",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "sort",
          title: "排序",
          width: "80"
        }),
        _createVNode(_component_vxe_column, {
          field: "created_at",
          title: "创建时间",
          width: "160"
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "150",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'cards_management_edit', params: { id: row.id } }))
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: ($event: any) => (_ctx.onDelete(row))
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.uploadDialogVisible,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.uploadDialogVisible) = $event)),
      title: "批量上传图片",
      width: "480px",
      "close-on-click-modal": false,
      "show-close": !_ctx.zipUploading,
      onClosed: _ctx.onUploadDialogClosed
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          disabled: _ctx.zipUploading,
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.uploadDialogVisible = false))
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: !_ctx.selectedZipFile,
          loading: _ctx.zipUploading,
          onClick: _ctx.onStartUpload
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "90px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "语系" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.uploadForm.card_language_id,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.uploadForm.card_language_id) = $event)),
                  placeholder: "全部语系（不限）",
                  clearable: "",
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languageOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "版本" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.uploadForm.card_version_id,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.uploadForm.card_version_id) = $event)),
                  placeholder: "全部版本（不限）",
                  clearable: "",
                  filterable: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versionOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "覆盖模式" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.uploadForm.overwrite,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.uploadForm.overwrite) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { value: false }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { value: true }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "ZIP 文件" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: _ctx.onSelectZip
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.selectedZipFile ? _ctx.selectedZipFile.name : '未选择文件'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "show-close", "onClosed"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.progressDialogVisible,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.progressDialogVisible) = $event)),
      title: "上传进度",
      width: "680px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: !_ctx.isProgressComplete,
          onClick: _ctx.onCloseProgress
        }, {
          default: _withCtx(() => [
            _hoisted_41
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      default: _withCtx(() => [
        (_ctx.uploadJobResult)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("strong", null, _toDisplayString(_ctx.uploadJobResult.matched_count), 1),
                _hoisted_25,
                _createElementVNode("strong", null, _toDisplayString(_ctx.uploadJobResult.unmatched_count || 0), 1),
                _hoisted_26
              ]),
              _createVNode(_component_el_progress, {
                percentage: _ctx.uploadProgressPercent,
                status: _ctx.uploadProgressStatus,
                style: {"margin-bottom":"12px"}
              }, null, 8, ["percentage", "status"]),
              _createElementVNode("div", _hoisted_27, " 状态：" + _toDisplayString(_ctx.uploadStatusText), 1),
              (_ctx.uploadStatus && _ctx.uploadStatus.results && _ctx.uploadStatus.results.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_el_table, {
                        data: _ctx.uploadStatus.results,
                        size: "small",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "filename",
                            label: "文件名",
                            "min-width": "180",
                            "show-overflow-tooltip": ""
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "card_name",
                            label: "卡牌名",
                            "min-width": "160",
                            "show-overflow-tooltip": ""
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "状态",
                            width: "80"
                          }, {
                            default: _withCtx(({ row }) => [
                              (row.status === 'success')
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 0,
                                    type: "success",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_31
                                    ]),
                                    _: 1
                                  }))
                                : (row.status === 'skipped')
                                  ? (_openBlock(), _createBlock(_component_el_tag, {
                                      key: 1,
                                      type: "info",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_32
                                      ]),
                                      _: 1
                                    }))
                                  : (row.status === 'error')
                                    ? (_openBlock(), _createBlock(_component_el_tag, {
                                        key: 2,
                                        type: "danger",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_33
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_el_tag, {
                                        key: 3,
                                        type: "info",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(row.status), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.uploadJobResult.unmatched && _ctx.uploadJobResult.unmatched.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, " 未匹配文件（" + _toDisplayString(_ctx.uploadJobResult.unmatched.length) + " 个） ", 1),
                    _createElementVNode("div", _hoisted_36, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadJobResult.unmatched, (fname, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: idx,
                          style: {"font-size":"12px","color":"#e6a23c","line-height":"1.8"}
                        }, [
                          _createTextVNode(_toDisplayString(fname.filename) + " ", 1),
                          _createElementVNode("span", _hoisted_37, "（" + _toDisplayString(fname.reason) + "）", 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.uploadJobResult.duplicate_stems && _ctx.uploadJobResult.duplicate_stems.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, " 重复档名（" + _toDisplayString(_ctx.uploadJobResult.duplicate_stems.length) + " 个，已取最后一个） ", 1),
                    _createElementVNode("div", _hoisted_40, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadJobResult.duplicate_stems, (d, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: idx,
                          style: {"font-size":"12px","color":"#f56c6c","line-height":"1.8"}
                        }, _toDisplayString(d.stem) + "：保留 " + _toDisplayString(d.kept) + "，丢弃 " + _toDisplayString(d.dropped), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}